import { render, staticRenderFns } from "./mermaid.vue?vue&type=template&id=f25eb640"
import script from "./mermaid.vue?vue&type=script&lang=js"
export * from "./mermaid.vue?vue&type=script&lang=js"
import style0 from "./mermaid.vue?vue&type=style&index=0&id=f25eb640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports